(() => {
  const TIERS = [
    { min: 1, max: 9, discount: 0 },
    { min: 10, max: 24, discount: 8 },
    { min: 25, max: 49, discount: 12 },
    { min: 50, max: 99, discount: 18 },
    { min: 100, max: Infinity, discount: 22 }
  ];

  function init(widget) {
    if (widget.dataset.gvpReady === 'true') return;
    widget.dataset.gvpReady = 'true';

    const productInfo = widget.closest('product-info') || document;
    const quantityInput = productInfo.querySelector('input[name="quantity"]');
    if (!quantityInput) return;

    let baseCents = Number(widget.dataset.baseCents || 0);
    const orderMinimum = Number(widget.dataset.orderMinimum || 1);
    // Suggest the observed minimum without changing backend rules or clamping
    // later customer edits (they may be topping up an existing cart).
    if (Number(quantityInput.value) === 1 && orderMinimum > 1) quantityInput.value = String(orderMinimum);
    const currency = widget.dataset.currency || 'CAD';
    const locale = widget.dataset.locale || 'en-CA';
    const unitNode = widget.querySelector('[data-gvp-unit]');
    const totalNode = widget.querySelector('[data-gvp-total]');
    const savingNode = widget.querySelector('[data-gvp-saving]');
    const nudgeNode = widget.querySelector('[data-gvp-nudge]');
    const rows = [...widget.querySelectorAll('[data-tier-row]')];
    const money = cents => new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);

    function selectedPrice() {
      try {
        const variant = JSON.parse(productInfo.querySelector('[data-selected-variant]')?.textContent || 'null');
        if (Number.isSafeInteger(variant?.price) && variant.price >= 0) baseCents = variant.price;
      } catch (_) {}
      widget.dataset.baseCents = String(baseCents);
      const from = widget.querySelector('[data-gvp-from]');
      const single = widget.querySelector('[data-gvp-single]');
      if (from) from.textContent = money(Math.floor(baseCents * 78 / 100));
      if (single) single.textContent = `${money(baseCents)} each`;
      widget.querySelectorAll('[data-gvp-rate]').forEach(node => {
        node.textContent = `${money(Math.floor(baseCents * Number(node.dataset.gvpRate) / 100))} each`;
      });
    }

    function render() {
      selectedPrice();
      const quantity = Number(quantityInput.value);
      if (!Number.isSafeInteger(quantity) || quantity < 1 || !quantityInput.checkValidity()) {
        unitNode.textContent = money(baseCents);
        totalNode.textContent = 'Choose quantity';
        savingNode.textContent = '—';
        nudgeNode.textContent = 'Enter a valid whole-number quantity to see your estimate.';
        rows.forEach(row => row.classList.remove('is-active'));
        return;
      }
      const tier = TIERS.find(item => quantity >= item.min && quantity <= item.max) || TIERS[0];
      const unitCents = Math.floor(baseCents * (100 - tier.discount) / 100);
      const listTotalCents = baseCents * quantity;
      const savingCents = Math.round(listTotalCents * tier.discount / 100);
      const totalCents = listTotalCents - savingCents;

      unitNode.textContent = money(unitCents);
      totalNode.textContent = money(totalCents);
      savingNode.textContent = money(savingCents);

      rows.forEach(row => {
        const min = Number(row.dataset.min);
        const max = Number(row.dataset.max);
        row.classList.toggle('is-active', quantity >= min && quantity <= max);
      });

      if (quantity < orderMinimum) {
        nudgeNode.textContent = `Minimum order: ${orderMinimum} units of this product. Your cart must meet that minimum before checkout.`;
        return;
      }

      if (quantity >= 250) {
        const link = document.createElement('a');
        link.href = widget.dataset.quoteTarget || '/pages/contact';
        link.textContent = '22% tier included. Request a project quote for 250+ units.';
        nudgeNode.replaceChildren(link);
        return;
      }

      const next = TIERS.find(item => item.min > quantity);
      if (!next) {
        nudgeNode.textContent = 'Your quantity qualifies for the best listed automatic tier: 22% off.';
        return;
      }
      const needed = next.min - quantity;
      nudgeNode.textContent = `Add ${needed} more to unlock ${next.discount}% off.`;
    }

    quantityInput.addEventListener('input', render);
    quantityInput.addEventListener('change', render);
    productInfo.addEventListener('click', event => {
      if (event.target.closest('quantity-input button')) window.setTimeout(render, 40);
    });
    // Dawn replaces the option picker and native price without replacing this
    // custom block. Read the newly selected variant after its normal update.
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (widget.isConnected && data.sectionId === productInfo.dataset.section) render();
      });
      subscribe(PUB_SUB_EVENTS.quantityUpdate, () => { if (widget.isConnected) render(); });
    }
    render();
  }

  function boot() {
    document.querySelectorAll('[data-gifty-volume-pricing]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
